import React from 'react';

// Base
import Card from '../../../../../base/card';
import Col from '../../../../../base/col';
import Placeholder from '../../../../../base/placeholder';
import Row from '../../../../../base/row';

export default class Loading extends React.Component {
  render() {
    return (
      <Card
        border='none'
        className='min-height-80'
        noPadding
      >
        <Row className='margin-top-15 margin-bottom-10' nested>
          <Col s={12} className='med-font dark margin-bottom-10'>
            Technical Expertise
          </Col>
          <Col s={12}>
            <Placeholder lines={1} />
          </Col>
        </Row>
      </Card>
    )
  }
}